// ABOUTME: Route wrapper that redirects users to correct path based on timezone
// ABOUTME: Hawaii users get /ohana paths, non-Hawaii users get /family paths

import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTimezone } from '../contexts/TimezoneContext';

interface TimezoneAwareRouteProps {
  children: React.ReactNode;
}

const TimezoneAwareRoute: React.FC<TimezoneAwareRouteProps> = ({ children }) => {
  const { familyTimezone } = useTimezone();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const isHawaii = familyTimezone === 'Pacific/Honolulu';
    const currentPath = location.pathname;

    // Hawaii timezone should use /ohana paths
    if (isHawaii && currentPath.includes('/family')) {
      const newPath = currentPath.replace('/family', '/ohana');
      navigate(newPath, { replace: true });
      return;
    }

    // Non-Hawaii timezone should use /family paths
    if (!isHawaii && currentPath.includes('/ohana')) {
      const newPath = currentPath.replace('/ohana', '/family');
      navigate(newPath, { replace: true });
      return;
    }
  }, [familyTimezone, location.pathname, navigate]);

  return <>{children}</>;
};

export default TimezoneAwareRoute;
